import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "hint"]

  check() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value

    if (confirmation.length === 0) {
      this.hintTarget.textContent = ""
      this.hintTarget.className = "password-match-hint"
      return
    }

    if (password === confirmation) {
      this.hintTarget.textContent = "Passwords match"
      this.hintTarget.className = "password-match-hint password-match-hint--match"
    } else {
      this.hintTarget.textContent = "Passwords don't match"
      this.hintTarget.className = "password-match-hint password-match-hint--mismatch"
    }
  }
}
